
webpack.register(
    'components/modal-dialog/information-modal/information-modal',
    function() {
        return import('components/modal-dialog/information-modal/information-modal');
    },
    true
);